import { FOCO_VISIVEL } from 'utils/foco';

/** Aviso amarelo da IN 403-1, item 1.6 (CAT-06). O texto da regra é o de produção; "Lembre-se:" é do design. */
export default function AvisoDeImpedimento() {
  return (
    <section
      aria-label="Aviso sobre impedimentos"
      tabIndex={0}
      className={`mb-6 flex items-center gap-3.5 rounded-xl bg-brand-yellow-light px-[22px] py-4 ${FOCO_VISIVEL}`}
    >
      <span aria-hidden="true" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-blue">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--brand-white)" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" focusable="false">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
      </span>
      <p className="m-0 text-[13px] leading-[1.6] text-content">
        <b className="text-brand-blue-dark">Lembre-se:</b> O crédito da premiação está condicionado a verificação de
        impedimentos, conforme IN 403-1, item 1.6. A verificação do impedimento terá como base a situação apurada no dia
        anterior ao pagamento do ciclo.
      </p>
    </section>
  );
}
